import React, { useContext, useState } from 'react'
import cn from 'classnames'
import { Button, ButtonStyles, FixedSpacer, Typography } from '@grammarly/badger-ui'

import { gnarSpec } from '../../../../lib/tracking/gnar'
import { PageContext } from '../../../../contexts/page-context'
import { renderRichTextSingleLineContent } from '../../../renderer/rich-text'

import { FULLSTORY_MASK_CLASSNAME } from '../../../../lib/tracking/fullstory/constants'
import { withPublicAssetUrl } from '../../../../lib/utils/cdn'
import { useBrowserService } from '../../../../lib/hooks'
import { useGoTemplates } from '../go-templates-context'

import styles from './output.module.scss'

const copyText = 'Copy'
const clipboardCopiedText = 'Copied to clipboard!'

const { TM, C1, C4 } = Typography

export const SkeletonLines = React.memo((props: { numLines: number }) => {
  const { numLines } = props
  const skeletonLines = Array.from({ length: numLines }, () => Math.random())

  return (
    <>
      {skeletonLines.map((val, index) => (
        <div key={`${val}-${index}`} className={styles.skeletonLine} style={{ marginRight: `${val * 30}px` }}></div>
      ))}{' '}
    </>
  )
})

export const Output: React.FC = () => {
  const { output, outputLabel, outputDescription, isLoading } = useGoTemplates()
  const { pageId, slug } = useContext(PageContext)
  const [copyBtnText, setCopyBtnText] = useState(copyText)
  const { isMobileOrTablet } = useBrowserService()

  const copy = () => {
    gnarSpec.goToolsCtaClick('copy', pageId, slug)

    setCopyBtnText(clipboardCopiedText)
    void navigator?.clipboard.writeText(output)
    setTimeout(() => setCopyBtnText(copyText), 2000)
  }

  const hasOutput = output.length > 0

  if (isMobileOrTablet && !hasOutput) {
    return null
  }

  return (
    <div className={cn(styles.outputContainer, isMobileOrTablet && styles.mobile)}>
      <TM as="div" className={styles.outputLabel}>
        {renderRichTextSingleLineContent(outputLabel)}
      </TM>
      <div className={styles.outputContent}>
        {hasOutput ? (
          <>
            <C4 as="div" className={cn(FULLSTORY_MASK_CLASSNAME, styles.outputText)}>
              {output}
            </C4>
            <div className={styles.actionRow}>
              <Button className={ButtonStyles.GreenButtonWhiteText24} padding="compact" onClick={copy}>
                {copyBtnText}
              </Button>
            </div>
          </>
        ) : isLoading ? (
          <>
            <SkeletonLines numLines={8} />
          </>
        ) : (
          <div className={styles.outputDescription}>
            <FixedSpacer multiplier={5} />
            <img src={`${withPublicAssetUrl('go-templates-tool/output-description.svg')}`} alt="" />
            <FixedSpacer multiplier={3} />
            <C1 as="div" bold>
              Let&apos;s get started
            </C1>
            <FixedSpacer multiplier={2} />
            <C4 as="div">{renderRichTextSingleLineContent(outputDescription)}</C4>
          </div>
        )}
      </div>
    </div>
  )
}
